// extracted by mini-css-extract-plugin
export default {"success":"StateIcon_success__fi758","error":"StateIcon_error__Lj3-2","refresh":"StateIcon_refresh__-KUi9"};